import React, { useEffect, useState } from "react";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";

function useIsDesktopMd() {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia("(min-width: 768px)").matches;
  });

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const onChange = () => setIsDesktop(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}

const PortalLayout = ({ children }) => {
  const [showNav, setShowNav] = useState(true);
  const location = useLocation();
  const isDesktop = useIsDesktopMd();

  // Close mobile drawer when switching to desktop to avoid stale open state
  useEffect(() => {
    if (isDesktop) setShowNav(false);
  }, [isDesktop]);

  if (["/login", "/", "/forgot-password"].includes(location.pathname.toLowerCase())) {
    return children;
  }

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <div className="flex-shrink-0 w-full">
        <Topbar showNav={showNav} setShowNav={setShowNav} />
      </div>

      <div className="flex flex-1 min-h-0 flex-col md:flex-row relative">
        <div className="flex-shrink-0 transition-all duration-[400ms]">
          {!isDesktop ? (
            <>
              {showNav && (
                <div
                  className="fixed inset-0 z-40 bg-black/40"
                  onClick={() => setShowNav(false)}
                />
              )}
              <div
                className={`fixed z-50 inset-y-0 left-0 w-64 transform bg-black rounded-r-xl shadow-xl transition-transform duration-300 ${
                  showNav ? "translate-x-0" : "-translate-x-full"
                }`}
              >
                <Sidebar onClose={() => setShowNav(false)} />
              </div>
            </>
          ) : (
            <div className="flex-shrink-0 w-64 lg:w-72 sticky top-0 self-start max-h-[calc(100vh-80px)] overflow-y-auto overflow-x-hidden no-scrollbar">
              <Sidebar />
            </div>
          )}
        </div>

        <div className="flex-1 min-h-0 transition-all duration-[400ms] pl-0 md:pl-1 lg:pl-2 flex flex-col overflow-hidden">
          <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden pb-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalLayout;
